/* istanbul ignore file */
import * as yup from 'yup';
import { requiredMsg } from '../../../utils/validationMessages';

export const ChecklistItemSchema = yup.object().shape({
  name: yup.string().required(requiredMsg('Name')),
  instructions: yup.string(),
  frequency: yup.string().required(requiredMsg('Frequency')),
});
